module.exports.logica_marcaciones = function logica_marcaciones(input) {
  F = {
    0: 1,
    1: 1,
    2: 0,
    3: 0,
    11: 3.2616782633265453e-13,
    4: -28.751364341308545,
    5: -28.751364341308737,
    6: 8.580960269876092,
    7: -18.666153971795694,
    8: -18.66617063938933,
    9: -18.66618727910097,
    10: -18.66620394169674,
    12: 3.2616782633254815e-13,
    20: 0.3325699574649411,
    13: -1.1525726479320566,
    14: -0.6965843432349619,
    15: -0.7148027629128222,
    16: 0.19372872674355762,
    17: 0.22494771845533804,
    18: -13.36605571290759,
    19: 1.9970625635632109,
    21: 0.22196718085670838,
    29: 0.3685814349052153,
    22: -0.2800410781572304,
    23: -0.5383073012964452,
    24: 0.04743169898835098,
    25: -0.4574439151769237,
    26: -0.3494439460510016,
    27: -12.126894676956214,
    28: -12.126913693691261,
    30: 0.23272916074842784,
    38: 0.00023227940662653318,
    31: -8.367197878570323,
    32: -8.367337265637184,
    33: -39.686351146251944,
    34: 15.659495961319777,
    35: 15.659378551651008,
    36: 48.67297152895785,
    37: 15.813537905116707,
    39: 0.0002322254529037904,
  };
  F[0] = input[0];
  F[1] = input[1];
  F[2] = input[2];
  F[3] = input[3];
  F[4] = F[5];
  F[5] = F[6];
  F[5] += F[0] * F[7];
  F[5] += F[1] * F[8];
  F[5] += F[2] * F[9];
  F[5] += F[3] * F[10];
  F[11] = (1 / (1 + Math.exp(-F[5])));
  F[12] = F[11] * (1 - F[11]);
  F[13] = F[14];
  F[14] = F[15];
  F[14] += F[0] * F[16];
  F[14] += F[1] * F[17];
  F[14] += F[2] * F[18];
  F[14] += F[3] * F[19];
  F[20] = (1 / (1 + Math.exp(-F[14])));
  F[21] = F[20] * (1 - F[20]);
  F[22] = F[23];
  F[23] = F[24];
  F[23] += F[0] * F[25];
  F[23] += F[1] * F[26];
  F[23] += F[2] * F[27];
  F[23] += F[3] * F[28];
  F[29] = (1 / (1 + Math.exp(-F[23])));
  F[30] = F[29] * (1 - F[29]);
  F[31] = F[32];
  F[32] = F[33];
  F[32] += F[0] * F[34];
  F[32] += F[1] * F[35];
  F[32] += F[2] * F[36];
  F[32] += F[3] * F[37];
  F[38] = (1 / (1 + Math.exp(-F[32])));
  F[39] = F[38] * (1 - F[38]);
  const output = [];
  output[0] = F[11];
  output[1] = F[20];
  output[2] = F[29];
  output[3] = F[38];
  return output;
};



// WEBPACK FOOTER //
// ./src/js/redes.js